// extracted by mini-css-extract-plugin
module.exports = {"table":"RoadRepairTable_table__2SX21"};